import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const metrics = [
  {
    label: "Projects Delivered",
    value: "32+",
    icon: "FolderOpen"
  },
  {
    label: "Years of Engineering Experience",
    value: "4+",
    icon: "Clock"
  },
  {
    label: "System Reliability",
    value: "99.8%",
    icon: "Activity"
  },
  {
    label: "Client Satisfaction",
    value: "98%",
    icon: "Users"
  }
];

const ImpactSection = () => {
  return (
    <section className="py-24 bg-[#4D4C4A] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-sm font-bold uppercase tracking-[0.3em] text-[#91756A] mb-4">Our Impact</h2>
          <h3 className="text-4xl font-bold italic tracking-tighter">Measure of Excellence.</h3>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-12">
          {metrics.map((metric, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="text-center group"
            >
              <div className="w-16 h-16 mx-auto mb-6 border border-white/10 rounded-full flex items-center justify-center group-hover:bg-[#91756A] group-hover:border-[#91756A] transition-all duration-300">
                <Icon name={metric.icon} size={24} className="text-white group-hover:scale-110 transition-transform duration-300" />
              </div>
              <div className="text-4xl lg:text-5xl font-bold mb-2 italic tracking-tighter text-[#91756A] group-hover:text-white transition-colors duration-300">
                {metric.value}
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-white/50 group-hover:text-[#91756A] transition-colors duration-300">
                {metric.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;